class BlockListingAppart {
	constructor() {
		this.swipers = document.querySelectorAll('.block-appart .swiper');
		this.videos = document.querySelectorAll('.block-appart .video-pres-pop');

		if (this.swipers.length > 0) {
			this.initSwipers();
		}

		if (this.videos.length > 0) {
			this.initVideos();
		}
	}

	initSwipers() {
		this.swipers.forEach((slider) => {
			const swiper = new Swiper(slider, {
				speed: 400,
				spaceBetween: 30,
				loop: true,
				grabCursor: true,
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					clickable: true,
				},
			});
		});
	}

	initVideos() {
		this.videos.forEach((video) => {
			video.addEventListener('click', function() {
				$.magnificPopup.open({
					items: {
						src: video.getAttribute("href")
					},
					type: 'iframe',
					removalDelay: 300,
					mainClass: 'mfp-fade popup-video'
				});
			});
		});
	}
}